import React, { useState, useEffect } from "react";
import { GridColDef } from "@mui/x-data-grid-pro";
import { TablePage } from "components/alove/TablePage";
import { QuestionResponse } from "models/batch/QuestionResponse";
import { formatDateTime } from "utils/globalsUtils";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";
import { QuestionResponseType } from "models/batch/QuestionResponse";
import { makeRequest } from "utils/networkUtils";
import { getProfileResponsesDO, getQuestion } from "utils/questionsUtils";
import { ProfileQResponse, ProfileResponse } from "models/profile/ProfileResponse";
import { Question } from "models/batch/Question";
import { getProfileByAttribute } from "utils/enduserUtils";

export const AnswersList = ({ questionId }: { questionId: number }) => {
  // TODO: No PageNumber for 4.1.1, please review.
  // const pageNumber = PageNumber.ViewQuestionnaireAnswers;

  const [question, setQuestion] = useState<Question>()

  const columns: GridColDef<ProfileResponse>[] = [{
    headerName: "Answer",
    field: "response",
    valueFormatter: (params: any) => question?.responses.find(r => r.txtId == params)?.txt || params,
    flex: 3,
  },
  {
    headerName: "Count",
    field: "count",
    flex: 1,
  }
  ];

  const filters = [{
    label: "reported",
    type: "date",
  }];

  const loadAnswers = async (filters: any, page: number) => {
    let _question = question;
    if (!_question) {
        _question = await getQuestion(questionId);
      setQuestion(_question);
    }
    const responses = await getProfileResponsesDO(_question!.batchContents?.map(c => c.id).join(","), filters);
    return Object.keys(responses).map(key => ({
      response: key,
      count: responses[key]
    }));
  };
  const onRowClick = ({row}) => {
    getProfileByAttribute(question?.profileAttr || question?.batchContents[0]?.id?.toString() || "", row.response).then((res) => {
      res.slice(0, 3).forEach((profile) => {
        window.open(`#/endusers/${profile.profileId}`, "_blank");
      }
      );
    })
  }

  return (
    <TablePage
      title={question?.txt || "Answers List"}
      table={{
        getRowId: (row) => row.response,
        columns,
        loadNext: loadAnswers,
        lineDoubleClick: onRowClick,
        lineClick: (_) => {}

      }}
      filters={filters}
    />
  );
}; 